export enum MetricType {
  CurrentAmp = 'currentAmp',
  PowerKw = 'powerKw',
  EstimatedKw = 'estimatedKw',
  WaterPressureIn = 'waterPressureIn',
  WaterPressureOut = 'waterPressureOut',
  WaterPressureDelta = 'waterPressureDelta',
  PressureBar = 'pressureBar',
  FlowM3Min = 'flowM3Min',
  WaterFlowM3Min = 'waterFlowM3Min',
  AirTemperatureCelsius = 'airTemperatureCelsius',
  EstimatedFlowM3Min = 'estimatedFlowM3Min',
  TempCelsius = 'tempCelsius',
  InletWaterTemperatureCelsius = 'inletWaterTemperatureCelsius',
  OutletWaterTemperatureCelsius = 'outletWaterTemperatureCelsius',
  HumidityPercentage = 'humidityPercentage',
  Activity = 'activity',
  ExtendedActivity = 'extendedActivity',
  OperationMode = 'operationMode',
  RemoteMode = 'remoteMode',
  InverterSpeedRPM = 'inverterSpeedRPM',
  EstimatedInverterSpeedRPM = 'estimatedInverterSpeedRPM',
  RunHours = 'runHours',
  LoadHours = 'loadHours',
  RunMinutes = 'runMinutes',
  MinimumPressureBar = 'minimumPressureBar',
  MaximumPressureBar = 'maximumPressureBar',
  NextServiceHours = 'nextServiceHours',
  NextServiceName = 'nextServiceName',
  OilTemperatureCelsius = 'oilTemperatureCelsius',
  PipeDiameter = 'pipeDiameter',
  SpecificPower = 'specificPower',
  MaxInverterSpeedRPM = 'maxInverterSpeedRPM',
  MinInverterSpeedRPM = 'minInverterSpeedRPM',
  DewpointTemperatureCelsius = 'dewpointTemperatureCelsius',
  Last24HrsCycles = 'last24HrsCycles',
  Last24HrsLoadAvg = 'last24HrsLoadAvg',
  Last24HrsUnloadAvg = 'last24HrsUnloadAvg',
  VSDPressureSetpointTargetBar = 'VSDPressureSetpointTargetBar',
  MaxMinDeltaPressureBar = 'maxMinDeltaPressureBar',
  EstimatedSpecificPower = 'estimatedSpecificPower',
  PoweredOn = 'poweredOn',
  InletValveOpening = 'inletValveOpening',
  BypassValveOpening = 'bypassValveOpening',
  CentrifugalTargetSetpoint = 'centrifugalTargetSetpoint',
  ValveActivity = 'valveActivity',
  ValveSetpoint = 'valveSetpoint',
  ValveAction = 'valveAction',
  ValveMinSetpoint = 'valveMinSetpoint',
  ValveMaxSetpoint = 'valveMaxSetpoint',
  ValveCurrentPosition = 'valveCurrentPosition',
  ValveDefaultState = 'valveDefaultState',
  SpillValveHpLowLimitSetpointBar = 'spillValveHpLowLimitSetpointBar',
  SpillValveHpPressureBar = 'spillValveHpPressureBar',
  SpillValveLpTargetSetpointBar = 'spillValveLpTargetSetpointBar',
  SpillValveLpPressureBar = 'spillValveLpPressureBar',
  DryerFilterServiceHours = 'dryerFilterServiceHours',
  DryerDesiccantServiceHours = 'dryerDesiccantServiceHours',
  DryerValveServiceHours = 'dryerValveServiceHours',
  DryerLeftTowerActivity = 'dryerLeftTowerActivity',
  DryerRightTowerActivity = 'dryerRightTowerActivity',
  DryerBlowerActivity = 'dryerBlowerActivity',
  DryerHeaterActivity = 'dryerHeaterActivity',
  DryerTemperatureSetpointCelsius = 'dryerTemperatureSetpointCelsius',
  DryerOperationMode = 'dryerOperationMode',
  DryerExtendedActivity = 'dryerExtendedActivity',
  ControlMode = 'controlMode',
  BypassValveUnloadPointPercent = 'bypassValveUnloadPointPercent',
  TargetPressureReloadPercent = 'targetPressureReloadPercent',
  AutoHotStartBar = 'autoHotStartBar',
  MotorWindingTemperatureCelsius = 'motorWindingTemperatureCelsius',
  AirDischargeTemperatureCelsius = 'airDischargeTemperatureCelsius',
  FirstStageTemperatureCelsius = 'firstStageTemperatureCelsius',
  SecondStageTemperatureCelsius = 'secondStageTemperatureCelsius',
  ThirdStageTemperatureCelsius = 'thirdStageTemperatureCelsius',
  FourthStageTemperatureCelsius = 'fourthStageTemperatureCelsius',
  SurgeCount = 'surgeCount',
  VibrationsLimitMicrons = 'vibrationsLimitMicrons',
  FirstStageVibrationsMicrons = 'firstStageVibrationsMicrons',
  SecondStageVibrationsMicrons = 'secondStageVibrationsMicrons',
  ThirdStageVibrationsMicrons = 'thirdStageVibrationsMicrons',
  FourthStageVibrationsMicrons = 'fourthStageVibrationsMicrons',
  VoltageVolt = 'voltageVolt',
  PowerFactor = 'powerFactor',
  IntercoolerPressureBar = 'intercoolerPressureBar',
  InteriorAmbientTemperatureCelsius = 'interiorAmbientTemperatureCelsius',
  ExteriorAmbientTemperatureCelsius = 'exteriorAmbientTemperatureCelsius',
  InfluentFlowM3Hour = 'influentFlowM3Hour',
  DissolvedOxygenPPM = 'dissolvedOxygenPPM',
  MinimumDissolvedOxygenPPM = 'minimumDissolvedOxygenPPM',
  MaximumDissolvedOxygenPPM = 'maximumDissolvedOxygenPPM',
  TargetDissolvedOxygenPPM = 'targetDissolvedOxygenPPM',
  PH = 'Ph',
  AmmoniaAmmoniumPPM = 'ammoniaAmmoniumPPM',
  NitratePPM = 'nitratePPM',
  NitritePPM = 'nitritePPM',
  OxidationReductionPotentialMV = 'oxidationReductionPotentialMV',
  BlowerSpeedRPM = 'blowerSpeedRPM',
  MinimumBlowerSpeedRPM = 'minimumBlowerSpeedRPM',
  MaximumBlowerSpeedRPM = 'maximumBlowerSpeedRPM',
  TargetBlowerSpeedRPM = 'targetBlowerSpeedRPM',
  FrequencyHz = 'frequencyHz',
  HorsePower = 'hp',
  WaterTemperatureCelsius = 'waterTemperatureCelsius',
  WorkingHours = 'workingHours',
  IsMinLoaded = 'isMinLoaded',
  IsMaxLoaded = 'isMaxLoaded',
  IsFullLoaded = 'isFullLoaded',
  IsCheckValveClosed = 'isCheckValveClosed',
  GeneralShutdown = 'generalShutdown',
  FiveLoopPressureOffset = 'fiveLoopPressureOffset',
  PerformanceLoss = 'performanceLoss',
  VibrationGearbox = 'vibrationGearbox',
  RotorSpeedRPM = 'rotorSpeedRPM',
  SuctionPressure = 'suctionPressure',
  OperatingHours = 'operatingHours',
  DischargeTemperatureCelsius = 'dischargeTemperatureCelsius',
  TargetPressureBand1Bar = 'targetPressureBand1Bar',
  TargetPressureBand2Bar = 'targetPressureBand2Bar',
  AirendInletCoolantTempCelsius = 'airendInletCoolantTempCelsius',
  AirendOutletCoolantTempCelsius = 'airendOutletCoolantTempCelsius',
  InletAirTemperatureCelsius = 'inletAirTemperatureCelsius',
  AirendTemperatureCelsius = 'airendTemperatureCelsius',
  TempCelsiusTSE = 'tempCelsiusTSE',
  UnloadToOffSeconds = 'unloadToOffSeconds',
  LocalStationControl = 'localStationControl',
  StationOnOff = 'stationOnOff',
  PressureBand = 'pressureBand',
  MinimumPressureBand1Bar = 'minimumPressureBand1Bar',
  MaximumPressureBand1Bar = 'maximumPressureBand1Bar',
  MinimumPressureBand2Bar = 'minimumPressureBand2Bar',
  MaximumPressureBand2Bar = 'maximumPressureBand2Bar',
  AutoStop = 'autoStop',
  ImmediateStop = 'immediateStop',
  Modulation = 'modulation',
  FlowM3HourPump = 'flowM3HourPump',
}
